import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\ttext-decoration: none;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var BaseLink = css(_templateObject());
export var Link = css(_templateObject2(), ui.get('linkColor'), ui.get('linkColorHover'));